module.exports = __webpack_public_path__ + "fonts/qanelas_soft_semi_bold.620ec121.otf";